import { type FC, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { usePromocodesQuery } from "@/partner/entities/promocodes";

interface PromocodeOption {
  value: string;
  label: string;
}

interface PromocodesAutocompleteProps {
  label: string;
  value: string[];
  onChange: (promocodeIds: string[]) => void;
}

// Тот же паттерн, что ContentsAutocomplete/TagsAutocomplete — список
// PromocodesList (usePromocodesQuery) вместо отдельного autocomplete-
// резолвера (в отличие от promocodeCampaigns, для которых он уже есть —
// см. PromocodeCampaignsAutocomplete.tsx). Подпись опции — код промокода.
// Чипы уже выбранных id, не попавших в текущую страницу результатов,
// останутся без подписи, пока пользователь не введёт search, который их
// найдёт (см. ContentsAutocomplete.tsx).
export const PromocodesAutocomplete: FC<PromocodesAutocompleteProps> = ({
  label,
  value,
  onChange,
}) => {
  const [search, setSearch] = useState("");

  const { data, loading } = usePromocodesQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      filter: { search: search || undefined },
      page: 0,
      rowsPerPage: 20,
    },
  });

  const options: PromocodeOption[] = (data?.promocodes?.nodes ?? []).map(
    (node) => ({
      value: node.id,
      label: node.code,
    })
  );

  return (
    <Autocomplete<PromocodeOption, true>
      multiple
      fullWidth
      filterOptions={(opts) => opts}
      loading={loading}
      options={options}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selected) =>
        option.value === selected.value
      }
      value={options.filter((option) => value.includes(option.value))}
      onInputChange={(_event, newInputValue, reason) => {
        setSearch(reason === "reset" ? "" : newInputValue);
      }}
      onChange={(_event, newValue) => {
        onChange(newValue.map((option) => option.value));
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
};
